import { Ontario } from '../../../entity'
import { person } from './person'

export const lessor = person

export type Lessor = Ontario.Lessor
